var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandedDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5732V13.4094",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0035 2.47729C10.8645 2.47729 9.68196 2.47729 8.62896 2.60965C7.68806 2.72791 6.927 3.44778 6.79721 4.38715C6.71875 4.95513 6.71875 5.54415 6.71875 6.52521C6.71875 7.50626 6.71875 8.0953 6.79721 8.66328C6.927 9.60265 7.68806 10.3225 8.62896 10.4408C9.68196 10.5731 10.8645 10.5731 12.0035 10.5731C13.1426 10.5731 14.3251 10.5731 15.3781 10.4408C16.319 10.3225 17.0801 9.60265 17.2098 8.66328C17.2883 8.0953 17.2883 7.50626 17.2883 6.52521C17.2883 5.54415 17.2883 4.95513 17.2098 4.38715C17.0801 3.44778 16.319 2.72791 15.3781 2.60965C14.3251 2.47729 13.1426 2.47729 12.0035 2.47729Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24869 21.5255C4.16217 20.2936 4 18.9872 4 17.6345C4 17.1614 4.01984 16.6939 4.04934 16.2333C4.14195 14.7876 5.29369 13.6608 6.7408 13.5936C8.76687 13.4994 11.3327 13.4094 11.9993 13.4094C12.6658 13.4094 15.2317 13.4994 17.2578 13.5936C18.705 13.6608 19.8566 14.7876 19.9492 16.2333C19.9788 16.6939 19.9987 17.1614 19.9987 17.6345C19.9987 18.9872 19.8364 20.2936 19.7499 21.5255",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00391 17.4675C5.60825 17.5673 10.2361 17.7663 11.9977 17.7663C13.7593 17.7663 18.3872 17.5673 19.9916 17.4675",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandedDesign);
export default __webpack_public_path__ + "static/media/Branded Design.b1d2a0671295352d1642de4959a9e345.svg";
export { ForwardRef as ReactComponent };